import BasePayload from "../base-payload.ts";
import IncomingPayloadEvent from "../../enums/incoming-payload-event.ts";
import ParseUtils from "../../utils/parse-utils.ts";

export default class BaseIncomingPayload extends BasePayload {
  constructor(payload: Record<string, unknown>, expectedEvent: IncomingPayloadEvent) {
    const event: string = ParseUtils.parseString(payload, "event", expectedEvent);
    const id: string = ParseUtils.parseString(payload, "id");
    super(event, id);
  }
}
